import React from 'react';
import Layout from '@/common/Layout';
import StaffingPage from './components/StaffingPage';

const index = () => {
  return (
    <div>
      <Layout sider={false}>
        <StaffingPage />
      </Layout>
    </div>
  );
};

export default index;
